<template>
  <div class="sessions-container">
    <div v-if="loading" class="text-center text-muted mb-4">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div v-if="loading === false && data.length === 0" class="card card-sm">
        <div class="card-body">
          Chưa có lịch chiếu cho ngày này. Hãy quay lại sau. Xin cám ơn.
        </div>
      </div>
      <div v-for="d in data" :key="d.movie.id" class="card card-sm mb-3"
           :class="{ 'card-sponsored': d.movie.sponsored }">
        <div class="card-body">
          <div class="row">
            <div class="col-3 col-sm-2">
              <a :href="root.url('orn_web_movie_view', { slug: d.movie.slug })">
                <img :src="d.movie.poster ? d.movie.poster : root.asset('bundles/ornweb/img/no-poster.png') "
                     :alt="d.movie.name" class="rounded img-fluid">
              </a>
            </div>
            <div class="col ml-n2">
              <h4 class="card-title mb-1 name">
                <a :href="root.url('orn_web_movie_view', { slug: d.movie.slug })">{{ d.movie.name }}</a>
              </h4>

              <p class="card-text small text-muted mb-0">
                <template v-if="d.movie.alias && d.movie.alias !== d.movie.name">
                  {{ d.movie.alias }} &middot;
                </template>
                <template v-if="d.movie.mpaa">
                  {{ d.movie.mpaa }} &middot;
                </template>
                <template v-if="d.movie.duration">
                  {{ useFormatting().formatMinutes(d.movie.duration) }} &middot;
                </template>
                <template v-if="d.movie.trailer">
                  <a href="#"
                     @click.prevent="useBootstrap().openVideoModal(d.movie.trailer.code)"
                  >Trailer</a>
                </template>
              </p>

              <div class="mt-2">
                <div v-for="(sessions, format) in d.sessions" :key="format" class="mb-1">
                  <label class="small mb-2 font-weight-bold d-block text-dark">
                    {{ useFormatting().formatFormat(format) }}
                  </label>
                  <a v-for="session in sessions"
                     :key="session.id"
                     :href="root.url('booking_index', { id: session.id })"
                     :data-id="session.id"
                     class="btn btn-sm btn-showtime mr-1"
                     :class="{'disabled btn-light': isSessionExpired(session.time), 'btn-outline-dark': !isSessionExpired(session.time)}"
                     >
                    <span class="time">{{ useFormatting().formatTime(session.time) }}</span>
                    <span v-if="session.price" class="amenity price">{{ session.price }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, onMounted, ref, watch } from 'vue';
import { useFormatting } from '../composables/formatting';
import { useBootstrap } from '../composables/bootstrap';
import axios from 'axios';

const props = defineProps({
  cinemaId: {
    type: String,
    required: true
  },
  date: {
    type: String,
    required: true
  },
})

const root = inject('root')

const loading = ref(true)
const data = ref([])

const getSessions = async () => {
  try {
    loading.value = true

    const response = await axios.get(`/cinema/${props.cinemaId}/sessions?date=${props.date}`)
    data.value = response.data
  } catch (error) {
    console.error('Error fetching sessions:', error)
  } finally {
    loading.value = false
  }
}

const isSessionExpired = (time) => {
  return new Date(time) <= new Date()
}

// watch session changed
watch(data, () => {
  data.value.forEach(d => {
    Object.values(d['sessions']).forEach(sessions => {
      sessions.forEach(session => {
        if (!session.price && ! isSessionExpired(session.time)) {
          axios.post('/session/prices', {
            sessions : [session.id]
          }).then(function (response) {
            session.price = response.data[session.id]
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    })
  })
})

// initialize
onMounted(() => {
  getSessions()
})
</script>

<style scoped>
</style>